import { render, staticRenderFns } from "./TitlePopup.vue?vue&type=template&id=06c96ea2"
import script from "./TitlePopup.vue?vue&type=script&lang=js"
export * from "./TitlePopup.vue?vue&type=script&lang=js"
import style0 from "./TitlePopup.vue?vue&type=style&index=0&id=06c96ea2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports